import { formatPrice } from 'utils';
import excel from '../../../../assets/images/Excel.svg'
import { Tooltip } from 'client/CommonComponents';
import '../PurchaseBulkOrder.scss'

const PurchaseBulkOrderHeader = (props?: any) => {
    const {
        itemDetails,
        onExportExcel,
        headerVendorDetails,
        isPOCreatedForAllItems
    } = props

    const address = () => {
        if (headerVendorDetails?.vendorName) {
            let val = (headerVendorDetails?.vendorAdd1 ? headerVendorDetails?.vendorAdd1 + ', ' : "") + (headerVendorDetails?.vendorAdd2 ? headerVendorDetails?.vendorAdd2 + ', ' : "") + (headerVendorDetails?.vendorCity ? headerVendorDetails?.vendorCity + ', ' : "") + (headerVendorDetails?.vendorState ? headerVendorDetails?.vendorState + ', ' : "") + (headerVendorDetails?.vendorZip ? headerVendorDetails?.vendorZip : "") || '-'
            return val;
        }
    }

return(
    <div className="accordionHeaderBlock">
                <div>
                    <label className="labelText">Request Type</label>
                    <Tooltip content={`${itemDetails?.requestType}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip">
                        <span className="dateContent">{itemDetails?.requestType || "-"}</span>
                    </Tooltip>
                </div>
                <div>
                    <label className="labelText">Qty</label>
                    <Tooltip content={`${itemDetails?.quantity}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_2">
                        <span className="dateContent">{itemDetails?.quantity || "-"}</span>
                    </Tooltip>
                </div>
                <div>
                    <label className="labelText">Asset Sourcing</label>
                    <Tooltip content={`${itemDetails?.assetSourcing}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_3">
                        <span className="dateContent">{itemDetails?.assetSourcing || "-"}</span>
                    </Tooltip>
                </div>
                <div>
                    <label className="labelText">Purchase Type</label>
                    <Tooltip content={`${itemDetails?.purchaseType}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_4">
                        <span className="dateContent">{itemDetails?.purchaseType || "-"}</span>
                    </Tooltip>
                </div>
                <div>
                    <label className="labelText">GL Code</label>
                    <Tooltip content={`${itemDetails?.glCode}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_5">
                        <span className="dateContent">{itemDetails?.glCode || "-"}</span>
                    </Tooltip>
                </div>
                <div>
                    {/* add condition here to show after po created */}
                    <label className="labelText">Spec</label>
                    <Tooltip content={`${itemDetails?.equipmentSpecification}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_6">
                        <span className="dateContent">{itemDetails?.equipmentSpecification || "-"}</span>
                    </Tooltip>
                </div>
                <div>
                    <label className="labelText">Price Per Unit</label>
                    <Tooltip content={`${itemDetails?.pricePerUnit ? formatPrice(itemDetails?.pricePerUnit, 2) : "-"}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_7">
                        <span className="dateContent">{itemDetails?.pricePerUnit ? `$${formatPrice(itemDetails?.pricePerUnit, 2)}` : "-"}</span>
                    </Tooltip>
                </div>
                <div className={`excel-section ${isPOCreatedForAllItems && !itemDetails?.isNonConsolidatedPOCreated ? '' : 'disable-export-excel'} `} >
                    <img src={excel} alt='excel' onClick={(e:any) => onExportExcel(e,itemDetails?.orderDetailId)} />
                </div>
                {(headerVendorDetails?.vendorName && itemDetails?.isVendorSaved) ?
                    <>
                        <div>
                            <label className="labelText">Vendor Name</label>
                            <Tooltip content={`${headerVendorDetails?.vendorName}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_8">
                                <span className="dateContent">{headerVendorDetails?.vendorName || "-"}</span>
                            </Tooltip>
                        </div>
                        <div>
                            <label className="labelText">Vendor Email</label>
                            <Tooltip content={`${headerVendorDetails?.vendorContactEmail}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_9">
                                <span className="dateContent">{headerVendorDetails?.vendorContactEmail || "-"}</span>
                            </Tooltip>
                        </div>
                        <div>
                            <label className="labelText">Vendor Phone</label>
                            <Tooltip content={`${headerVendorDetails?.vendorPhone}`} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_10">
                                <span className="dateContent">{headerVendorDetails?.vendorPhone || "-"}</span>
                            </Tooltip>
                        </div>
                        <div>
                            <label className="labelText">Vendor Address</label>
                            <Tooltip content={address() || ''} data-attribute="PurchaseBulkOrderHeader_Default_Tooltip_11">
                                <span className="dateContent">{address() || "-"}</span>
                            </Tooltip>
                        </div>
                    </>
                    : null}
            </div>
)
}

export default PurchaseBulkOrderHeader